var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelWebsite14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.003 3c.55 0 .997.453.997.997v6.006c0 .55-.453.997-.997.997H3.997c-.55 0-.997-.453-.997-.997V3.997c0-.55.453-.997.997-.997zM6.5 8h-2v1.5h2zm3 0h-2v1.5h2zM6 6H4v.5h2zm4 0H7v.5h3zm0-2H4v1h6z"
}))));
export default SvgChannelWebsite14;